// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LinkButton_link__IRp0r {
    font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    outline: none;
    color: var(--color-primary);
    border-radius: 4px;
}

.LinkButton_link__IRp0r:hover {
    cursor: pointer;
}

.LinkButton_link__IRp0r:focus-visible {
    outline: 2.5px solid var(--color-primary);
}

.LinkButton_link__IRp0r:focus-visible,
.LinkButton_link__IRp0r:hover {
    text-decoration: underline;
}

.LinkButton_link__IRp0r:disabled {
    cursor: not-allowed;
    opacity: 0.7;
    text-decoration: none;
}`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/LinkButton/LinkButton.module.css"],"names":[],"mappings":"AAAA;IACI,wEAAwE;IACxE,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;AACzB","sourcesContent":[".link {\n    font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    outline: none;\n    color: var(--color-primary);\n    border-radius: 4px;\n}\n\n.link:hover {\n    cursor: pointer;\n}\n\n.link:focus-visible {\n    outline: 2.5px solid var(--color-primary);\n}\n\n.link:focus-visible,\n.link:hover {\n    text-decoration: underline;\n}\n\n.link:disabled {\n    cursor: not-allowed;\n    opacity: 0.7;\n    text-decoration: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"link": `LinkButton_link__IRp0r`
};
export default ___CSS_LOADER_EXPORT___;
